document.addEventListener("DOMContentLoaded", () => {
    const featuredCollectionImage = document.querySelectorAll(".collection-image-wrapper");
    const slideshowImg = document.querySelectorAll(".slideshow-img-loader")
    const imgOptions = {};
    let imgObserver = new IntersectionObserver((entries, imgObserver) => {
        //console.log(entries);
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
           // console.log(entry.target.querySelector('img'));
            const img = entry.target.querySelector('img');
            const newURL = img.getAttribute('data-src');
            entry.target.querySelector('svg').remove();
            img.src = newURL;
            // img.src = img.src.replace("w=10&", "w=800&");
            imgObserver.unobserve(entry.target);
        });
    }, imgOptions);

    featuredCollectionImage.forEach((el) => {
        imgObserver.observe(el);
    });

    // const slideShowObserver = new IntersectionObserver((entries, imgObserver) => {
    //     console.log('SLIDESHOW ',entries);
    //     entries.forEach((entry) => {
    //         if (!entry.isIntersecting) return;
    //         console.log('SLIDESHOW ',entry.target.querySelector('img'));
    //         const img = entry.target.querySelector('img');
    //         const newURL = img.getAttribute('data-src');
    //         entry.target.querySelector('svg').remove();
    //         img.src = newURL;
    //         // img.src = img.src.replace("w=10&", "w=800&");
    //         imgObserver.unobserve(entry.target);
    //     });
    // }, imgOptions);

    slideshowImg.forEach((el) => {
        imgObserver.observe(el);
    });

});
